import React from "react";
import { Home } from "./Components/Home";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { MembersList } from "./Components/MembersList";
import Welcome from "./Components/Welcome";
import configure from "./Components/configure";
import PageNotFound from "./Components/PageNotFound";



const App = () => {


  return (
    <div className="App">
      <Router>
        <Switch>
          <Redirect exact from="/addmembers/:guid" to="/" />
          <Redirect exact from="/termsofservice" to="/pagenotfound" />
          <Route path="/welcome" exact component={Welcome} />
          <Route path="/" exact component={Home} />
          <Route path="/memberslist" component={MembersList} />
          <Route path="/configure" component={configure} />
          <Route path="/pagenotfound" exact component={PageNotFound} />
        </Switch>
      </Router>
    </div>
  );
};

export default App;